export default {
    title: 'ตั้งค่าเวลาการทำงาน',
    searchText: 'ค้นหาสำนักงาน',
    search: 'ค้นหา',

    bureau: 'สำนักงาน',
    acronym: 'ชื่อย่อสำนักงาน',
    workDay: 'วันทำงาน',
    totalEmployee: 'พนักงานทั้งหมด',
    updatedDate: 'อัปเดตเมื่อ',
    createdDate: 'วันที่สร้าง',
    action: ''
}
